import getEnv from '../helpers/getEnv';

export const ENDPOINT_BUSCA_CNPJ = `${getEnv(
  'redecredenciada',
)}/indicacao/indicacaoec/estabelecimento/consultarEstabelecimento/:cnpj`;
export const ENDPOINT_BUSCA_ENDERECO = `${getEnv(
  'redecredenciada',
)}/indicacao/indicacaoec/estabelecimento/buscarPorEndereco`;
export const ENDPOINT_FINALIZA_INDICACAO = `${getEnv(
  'redecredenciada',
)}/indicacao/indicacaoec/criarIndicacao`;
export const ENDPOINT_CATEGORIAS = `${getEnv(
  'redecredenciada',
)}/comum/indique-ec/setup`;
export const ENDPOINT_PRODUTOS = `${getEnv(
  'redecredenciada',
)}/indicacao/indicacaoec/produtos`;
export const ENDPOINT_PERGUNTAS = `${getEnv(
  'redecredenciada',
)}/indicacao/indicacaoec/perguntas/consultarPerguntas`;

export const urls = {
  login: 'login',
  register: 'cadastro',
  forgotMyPassword: 'esqueci-minha-senha',
  createNewPassword: 'criar-nova-senha',
  forgotMyEmail: 'esqueci-meu-email',
  validateCard: 'validar-cartao',
  home: 'home',
  changePersonalData: 'alterar-dados-pessoais',
  changeAccessData: 'alterar-dados-acesso',
  provisionalCard: 'cartao-provisorio',
  notifications: 'notificacoes',
  aditionalServices: 'servicos-adicionais',
};

export const firebaseConfig = {
  apiKey: 'AIzaSyBnvmWy4dGLyQOa0650vajCsLIkVgSxVYU',
  authDomain: 'portal-trabalhador.firebaseapp.com',
  databaseURL: 'https://portal-trabalhador.firebaseio.com',
  projectId: 'portal-trabalhador',
  storageBucket: 'portal-trabalhador.appspot.com',
  messagingSenderId: '504162020188',
  appId: '1:504162020188:web:df0d01d769e492a7fc2f99',
  measurementId: 'G-L2853NSRYB',
};

/**
 VRPAT: VR Benefícios
 JVCEF: Caixa Econômica Federal
 */
export const JVCEF = 'JVCEF';
export const VRPAT = 'VRPAT';

export const sensedia = {
  VRPAT: {
    PROD: {
      clientId: '08ddc279-b0ae-3aee-b628-7b4d5dc03f5c',
      clientSecret: '37f1424d-1504-3d0b-af2b-7497cc1d1e59',
    },
    NON_PROD: {
      clientId: '1e77365a-867f-3774-b662-493ebfa91290',
      clientSecret: '4b01cf13-e1fb-3612-afc3-2ac9d2fd699b',
    },
  },
  JVCEF: {
    PROD: {
      clientId: '425fd69e-cc6a-3700-bac8-d236d19a4829',
      clientSecret: 'd4dc07a3-6fa5-3857-a661-5705df498d18',
    },
    NON_PROD: {
      clientId: '16578c33-ecca-3f9b-a734-357f8fbf647d',
      clientSecret: 'd6e39b92-8e00-3f78-ad5a-f5029b22d84d',
    },
  },
};

export const DYNATRACE_SESSION_KEY = ')<0{uUZA';
export const DYNATRACE_SESSION_VALUE = '"+!*|Vz0';

export const ISSUER_SESSION_KEY = 'issuer';
